import { render, staticRenderFns } from "./MenuList.vue?vue&type=template&id=44bc7ebe&"
import script from "./MenuList.vue?vue&type=script&lang=ts&"
export * from "./MenuList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44bc7ebe')) {
      api.createRecord('44bc7ebe', component.options)
    } else {
      api.reload('44bc7ebe', component.options)
    }
    module.hot.accept("./MenuList.vue?vue&type=template&id=44bc7ebe&", function () {
      api.rerender('44bc7ebe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user-management/MenuList.vue"
export default component.exports